<template>
    <v-dialog v-model="dialog" max-width="800">
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-if="isNew" v-bind="attrs" v-on="on" bottom color="accent" dark fab fixed right>
                <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn v-else v-bind="attrs" v-on="on" small text>
                <v-icon small>mdi-pencil</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <template v-if="isNew">{{ title }} 등록</template>
                <template v-else>{{ title }} 상세</template>
            </v-card-title>
            <v-card-text>
                <v-text-field v-model="program.title" label="제목" v-bind="inputProps" class="mb-2" />
                <program-view-dates v-model="program" isApplicationDates />
                <program-view-dates v-model="program" />
                <file-chips-field v-model="program.files" label="첨부파일" class="py-2" v-bind="inputProps" />
                <naver-smarteditor v-model="program.content" rows="5" class="mt-2" style="max-height: 456px; overflow-y: auto" />
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-col cols="auto" class="pr-0">
                    <v-btn @click="dialog = false" color="grey" outlined>{{ closeButton }}</v-btn>
                </v-col>
                <v-col cols="auto">
                    <v-btn @click="save" color="primary">{{ saveButton }}</v-btn>
                </v-col>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import ProgramViewDates from "./program-view-dates.vue";
import NaverSmarteditor from "@/components/plugins/naver/naver-smarteditor.vue";
import FileChipsField from "../dumb/file-chips-field.vue";
const inputProps = {
    "hide-details": true,
    persistentPlaceholder: true,
    outlined: true,
    dense: true,
};
export default {
    components: {
        ProgramViewDates,
        NaverSmarteditor,
        FileChipsField,
    },
    props: {
        isNew: { type: Boolean, default: false },
        title: String,
        category: String,
        value: Array,
        item: Object,
    },
    data() {
        return {
            dialog: false,
            inputProps,
            program: {
                files: [],

                title: null,
                content: null,

                applicationStartsAt: null,
                applicationEndsAt: null,

                serviceStartsAt: null,
                serviceEndsAt: null,
            },
        };
    },
    computed: {
        closeButton() {
            if (this.isNew) return "취소";
            else return "닫기";
        },
        saveButton() {
            if (this.isNew) return "등록";
            else return "수정";
        },
    },
    watch: {
        async dialog() {
            if (this.dialog && this.item) {
                let program = { ...this.item };
                program.files = await Promise.all((program.files || []).map(async ({ url }) => await api.getResource(url, true)));

                if (program.applicationStartsAt) program.applicationStartsAt = program.applicationStartsAt.toDate();
                if (program.applicationEndsAt) program.applicationEndsAt = program.applicationEndsAt.toDate();
                if (program.serviceStartsAt) program.serviceStartsAt = program.serviceStartsAt.toDate();
                if (program.serviceEndsAt) program.serviceEndsAt = program.serviceEndsAt.toDate();

                this.program = program;
            }
        },
    },
    methods: {
        async save() {
            try {
                let {
                    isNew,
                    program: { _applications, _files = [], files = [], ...body },
                } = this;

                const { post, put } = api.console.services;
                let { program } = isNew ? await post({ ...body, category: this.category }) : await put(body);
                const _program = program?._id;

                await Promise.all(_files.map(async (_id) => await api.console.services.files.delete({ _program, _id })));
                _files = await Promise.all(files.map(async (file, index) => (await api.console.services.files.post({ _program, index }, file))?.file?._id));
                program = (await put({ _id: _program, _files }))?.program;

                let programs = [];

                if (isNew) {
                    programs = [program, ...this.value];
                } else {
                    programs = [...this.value];
                    const index = programs.findIndex(({ _id }) => _id == program._id);
                    programs.splice(index, 1, program);
                }

                this.$emit("input", programs);
                if (isNew) alert("등록되었습니다.");
                else alert("수정되었습니다.");
                this.dialog = false;
            } catch (error) {
                this.$handleError(error);
            }
        },
    },
};
</script>

<style></style>
